export enum Environment {
  Local = 'local',
  Dev = 'dev',
  Prod = 'prod',
  SSG = 'ssg',
}
